/**
 * Adapters from blustreamApi beta shape → legacy field shape this page renders.
 * Lets the JSX layer stay untouched while the data source moves to /api/beta/*.
 * Remove once render code is rewired directly to beta field names.
 */

export function journeyFromBeta(beta) {
  if (!beta) return beta;
  return {
    ...beta,
    Id: beta.journey_id,
    Name: beta.name,
    currentState: { state: beta.state_enum },
  };
}

export function touchpointFromBeta(beta, journeyId) {
  if (!beta) return beta;
  return {
    ...beta,
    id: beta.touchpoint_id,
    journeyId,
    name: beta.name,
    messageTemplateName: beta.name,
    messageContent: beta.message,
    wait: beta.wait_time,
    ordinal: beta.ordinal,
    contentLinkToTrackableLink: beta.link ? { [beta.link]: true } : null,
  };
}

